var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5182_31337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.0001 125.001C57.3111 124.993 45.0147 120.6 35.1941 112.565C25.3735 104.529 18.6324 93.3463 16.113 80.91C13.5935 68.4736 15.4506 55.5486 21.3695 44.3247C27.2885 33.1008 36.9054 24.268 48.5911 19.3227C62.0317 13.6448 77.1774 13.5388 90.6962 19.0279C104.215 24.517 115 35.1516 120.678 48.5922C126.355 62.0329 126.462 77.1785 120.972 90.6974C115.483 104.216 104.849 115.001 91.4081 120.679C84.6355 123.545 77.3542 125.015 70.0001 125.001ZM48.2001 66.1127C46.8247 66.1007 45.4999 66.6306 44.5121 67.5877C44.0342 68.0589 43.6548 68.6204 43.3958 69.2396C43.1368 69.8587 43.0034 70.5231 43.0034 71.1942C43.0034 71.8653 43.1368 72.5298 43.3958 73.1489C43.6548 73.768 44.0342 74.3295 44.5121 74.8007C54.9461 85.1697 57.0121 87.1927 57.4181 87.5817C57.7941 87.9667 58.6841 88.8727 60.7891 91.0007C69.7431 82.8527 95.2381 57.9397 95.4951 57.6887C95.973 57.2175 96.3524 56.656 96.6114 56.0369C96.8704 55.4178 97.0038 54.7533 97.0038 54.0822C97.0038 53.4111 96.8704 52.7467 96.6114 52.1276C96.3524 51.5084 95.973 50.9469 95.4951 50.4757C94.5008 49.5286 93.1803 49.0003 91.8071 49.0003C90.4339 49.0003 89.1134 49.5286 88.1191 50.4757L60.7901 76.5757L51.8901 67.5877C50.9018 66.6301 49.5762 66.1002 48.2001 66.1127Z",
    fill: "url(#paint0_linear_5182_31337)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 132C104.242 132 132 104.242 132 70C132 35.7583 104.242 8 70 8C35.7583 8 8 35.7583 8 70C8 104.242 35.7583 132 70 132Z",
    stroke: "#58924E",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 139C108.108 139 139 108.108 139 70C139 31.8924 108.108 1 70 1C31.8924 1 1 31.8924 1 70C1 108.108 31.8924 139 70 139Z",
    stroke: "#58924E",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5182_31337",
    x1: 106.205,
    y1: 30.6084,
    x2: 33.9241,
    y2: 109.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EE28D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AE60"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5182_31337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.75bb83ac8dbc8f90804903782125a122.svg";
export { ForwardRef as ReactComponent };